// Mock data — Admin panel (will be replaced by backend API)
export const adminStats = {
  users: 5214, proSubscribers: 388, newsletterSubs: 2941, chatSessions: 12730,
  frameworks: 26, glossaryTerms: 212, regulators: 6, workflows: 8,
  weeklySignups: [42, 51, 38, 64, 71, 58, 83],
  topPages: [
    { path: "/usa/cisa", views: 8421 },
    { path: "/money-flow", views: 7310 },
    { path: "/library/nist-csf", views: 6208 },
    { path: "/tools/grc-maturity", views: 5877 },
    { path: "/glossary/shadow-ai", views: 4102 }
  ]
};

export const adminUsers = [
  { id: "u1", name: "Sarah Mitchell", email: "sarah.m@countygov.tx.us", role: "admin", plan: "Pro", joined: "2025-02-14", lastActive: "2h ago" },
  { id: "u2", name: "James Rodriguez", email: "jrodriguez@firstnationalbk.com", role: "user", plan: "Pro", joined: "2025-03-02", lastActive: "1d ago" },
  { id: "u3", name: "Emily Chen", email: "echen@grcpartners.io", role: "editor", plan: "Pro", joined: "2025-03-18", lastActive: "4h ago" },
  { id: "u4", name: "Michael Thompson", email: "mthompson@cityofmesa.gov", role: "user", plan: "Free", joined: "2025-04-22", lastActive: "3d ago" },
  { id: "u5", name: "Ashley Williams", email: "awilliams@stateauditor.wa.gov", role: "user", plan: "Free", joined: "2025-05-09", lastActive: "6h ago" },
  { id: "u6", name: "David Park", email: "dpark@midwestcu.org", role: "user", plan: "Pro", joined: "2025-05-30", lastActive: "12h ago" },
  { id: "u7", name: "Jennifer Lopez", email: "jlopez@browardcounty.fl.gov", role: "user", plan: "Free", joined: "2025-06-11", lastActive: "1h ago" }
];

export const adminNewsletters = [
  { id: "n1", subject: "US Risk Desk #34 — CIRCIA final-rule watch", status: "Sent", date: "2025-07-14", opens: "61%", clicks: "19%" },
  { id: "n2", subject: "US Risk Desk #33 — CRE concentration heat check", status: "Sent", date: "2025-07-07", opens: "58%", clicks: "16%" },
  { id: "n3", subject: "US Risk Desk #35 — Money Flow launch", status: "Draft", date: "—", opens: "—", clicks: "—" }
];

export const adminWebinars = [
  { id: "w1", title: "US Risk Desk Live: Inside a 4-day SEC materiality call", guest: "Former SEC enforcement counsel", date: "2025-08-06", registrations: 412, status: "Upcoming" },
  { id: "w2", title: "County ransomware tabletop — live walkthrough", guest: "CISA regional advisor (ret.)", date: "2025-08-20", registrations: 287, status: "Upcoming" },
  { id: "w3", title: "Single Audit findings: FY24 patterns", guest: "Big 4 government-audit partner", date: "2025-07-09", registrations: 523, status: "Recording available" }
];

export const chatbotConfig = {
  name: "Sam", model: "claude-sonnet-4.5", temperature: 0.4, maxTokens: 1200,
  systemPromptPreview: "You are Sam, RiskPedia USA's AI risk advisor. You help US risk professionals, auditors and local-government leaders compare frameworks, decode regulations (SEC, Fed, CISA, FinCEN, NYDFS, NIST) and plan compliance...",
  guardrails: ["No legal advice — always add advisory disclaimer", "Cite framework/regulator sources when possible", "Escalate pricing questions to sales", "Educational purpose disclaimer on money-flow figures"]
};
